import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

export default class SlideBoxesTwo {
	constructor() {
		this.swiper = undefined;
	}

	init() {
		if ($('.slide-boxes-two__slideItem').length > 1) {
			this.swiper = new Swiper('.slide-boxes-two__slideActive', {
				speed: 1500,
				loop: true,
				modules: [Navigation, Pagination, Autoplay],
				slidesPerView: 'auto',
				spaceBetween: 0,
				slidesPerGroup: 1,
				loopAddBlankSlides: false,
				watchSlidesProgress: true,
				watchSlidesVisibility: true,
				preloadImages: true,
				updateOnImagesReady: true,
				mousewheel: true,
				simulateTouch: true,
				grabCursor: true,
				autoplay: {
					delay: 1000000,
					disableOnInteraction: false
				},
				navigation: {
					nextEl: '.slide-boxes-two__slideArrowNext',
					prevEl: '.slide-boxes-two__slideArrowPrev'
				},
				pagination: {
					el: '.slide-boxes-two__pagination',
					clickable: true,
					type: 'bullets'
				},
				breakpoints: {
					768: {
						slidesPerView: 1,
						slidesPerGroup: 1,
						spaceBetween: 25
					},
					1024: {
						slidesPerView: 3,
						slidesPerGroup: 3,
						spaceBetween: 25
					}
				}
			});

			if (this.swiper) {
				const observer = new IntersectionObserver(
					(entries) => {
						entries.forEach((entry) => {
							if (entry.isIntersecting) {
								// Start autoplay when visible
								this.swiper.autoplay.start();
							} else {
								// Stop autoplay when out of view
								this.swiper.autoplay.stop();
							}
						});
					},
					{
						threshold: 0.25 // slider must be 25% visible
					}
				);

				observer.observe(document.querySelector('.slide-boxes-two__slideActive'));

				if (window.matchMedia('(min-width: 1024px)').matches) {
					const prevZone = document.querySelector('.slide-boxes-two__hoverZone--prev');
					const nextZone = document.querySelector('.slide-boxes-two__hoverZone--next');

					let hoverInterval = null;
					const SLIDE_INTERVAL = 800; // ms between slides (tweak as needed)

					const startSliding = (direction) => {
						if (hoverInterval) return;

						hoverInterval = setInterval(() => {
							if (direction === 'next') {
								this.swiper.slideNext();
							} else {
								this.swiper.slidePrev();
							}
						}, SLIDE_INTERVAL);
					};

					const stopSliding = () => {
						if (hoverInterval) {
							clearInterval(hoverInterval);
							hoverInterval = null;
						}
					};

					prevZone?.addEventListener('mouseenter', () => startSliding('prev'));
					nextZone?.addEventListener('mouseenter', () => startSliding('next'));

					prevZone?.addEventListener('mouseleave', stopSliding);
					nextZone?.addEventListener('mouseleave', stopSliding);
				}
			}
		}
	}

	destroy() {
		if (this.swiper !== undefined) {
			this.swiper.destroy();
		}
	}
}
